import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import { Button, Card, Flex, Form, Spin, Steps, Typography } from "antd";

//PROJECT IMPORTS
import dayjs from "dayjs";
import Notiflix from "notiflix";
import { showCheckerApprovalModal } from "../../components/CheckerModal";
import MainLayout from "../../components/layouts/enhancement/MainLayout";
import TopContent from "../../components/layouts/enhancement/TopContent";
import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";
import ContactInformationForm from "./components/ContactInformationForm";
import GeneralInformationForm from "./components/GeneralInformationForm";
import OthersForm from "./components/OthersForm";
import Preview from "./components/Preview";
import { apiConfig, labelConfig, staticConfig } from "./serviceProvider.config";

const NewServiceProvider = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state: selectedBranchKey } = useLocation();
  const [current, setCurrent] = useState(0);

  // ENDPOINT DECLARED VARIABLES
  const [productData, setProductData] = useState([]);
  const { state } = useLocation();
  const isActive = Form.useWatch("active", useForm);
  const idType = Form.useWatch("idTypeId", useForm);
  const openCasa = Form.useWatch("openCasa", useForm);
  const legalOption = Form.useWatch("legalFormId", useForm);
  const agentTypeWatch = Form.useWatch("agentType", useForm);
  const dispatch = useDispatch();
  const [officeData, setOfficeData] = useState([]);
  const [legalFormData, setLegalFormData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [savingsProduct, setSavingsProduct] = useState([]);
  const [clientClassificationData, setClientClassificationData] = useState([]);
  const [
    clientNonPersonConstitutionOptions,
    setClientNonPersonConstitutionOptions,
  ] = useState([]);
  const [
    clientNonPersonMainBusinessLineOptions,
    setClientNonPersonMainBusinessLineOptions,
  ] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [identifactionTypeData, setIdentificattionTypeData] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [isAddressEnabled, setIsAddressEnabled] = useState(null);
  const [legalFormValue, setLegalFormValue] = useState(legalOption);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [filteredWalletProduct, setFilteredWalletProduct] = useState([]);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [customerList, setCustomerList] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    generalInfo: null,
    contactInfo: null,
    othersInfo: null,
  });

  const stepTitles = [
    "Product Information",
    "Contact Information",
    "Others",
    "Preview",
  ];

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  const minDate = dayjs().add(0, "day");

  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return (
        minDate != null &&
        current.isBefore(minDate) &&
        !current.isSame(minDate, "day")
      );
    },
    [minDate],
  );

  useEffect(() => {
    getTemplate();
    getAddress();
    getCustomerListAction();
    getProductTemplate();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Clients}/template?staffInSelectedOfficeOnly=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        setIsAddressEnabled(objList.isAddressEnabled);

        let tempOfficeData = [];
        let tempLegalFormData = [];
        let tempCustomerType = [];
        let tempTitle = [];
        let tempCountries = [];
        let tempCountryId = [];
        let tempAddressTypeId = [];
        let tempStateProvinceId = [];
        let tempGender = [];
        let tempIdentification = [];
        let tempClientClassification = [];
        let tempClientNonPersonConstitutionOptions = [];
        let tempClientNonPersonMainBusinessLineOptions = [];
        let tempStaffData = [];
        let tempSavingsProduct = [];
        // let tempActivationDate = '"' + objList?.activationDate.join("-") + '"';

        // console.log(objList);
        // return;

        objList?.officeOptions?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.clientLegalFormOptions?.forEach((element) => {
          tempLegalFormData.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.clientTypeOptions?.forEach((element) => {
          tempCustomerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.genderOptions?.forEach((element) => {
          tempGender.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.countryOptions?.forEach((element) => {
          tempCountries.push({
            value: element.description,
            label: element.name,
          });
        });

        objList?.clientClassificationOptions?.forEach((element) => {
          tempClientClassification.push({
            value: element.id,
            label: element.name,
          });
        });
        objList?.clientNonPersonConstitutionOptions?.forEach((element) => {
          tempClientNonPersonConstitutionOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.clientNonPersonMainBusinessLineOptions?.forEach((element) => {
          tempClientNonPersonMainBusinessLineOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });
        objList?.savingProductOptions
          ?.filter((item) => item.allowOverdraft === false)
          .forEach((element) => {
            tempSavingsProduct.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        // objList?.savingProductOptions?.forEach((element) => {
        //   tempSavingsProduct.push({
        //     value: element.id,
        //     label: element.name,
        //   });
        // });

        objList?.idTypes?.forEach((element) => {
          tempIdentification.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.address[0]?.countryIdOptions.forEach((element) => {
          tempCountryId.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.address[0]?.stateProvinceIdOptions.forEach((element) => {
          tempStateProvinceId.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.address[0]?.addressTypeIdOptions.forEach((element) => {
          tempAddressTypeId.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);
        setLegalFormData(tempLegalFormData);
        setCustomerTypeData(tempCustomerType);
        setTitleData(tempTitle);
        setSavingsProduct(tempSavingsProduct);
        // setActivationDate(dayjs(tempActivationDate));
        setClientClassificationData(tempClientClassification);
        setClientNonPersonConstitutionOptions(
          tempClientNonPersonConstitutionOptions,
        );
        setClientNonPersonMainBusinessLineOptions(
          tempClientNonPersonMainBusinessLineOptions,
        );
        setStaffData(tempStaffData);
        setCountryData(tempCountries);
        setCountryIdData(tempCountryId);
        setAddressTypeIdData(tempAddressTypeId);
        setStateProvinceIdData(tempStateProvinceId);
        setGenderData(tempGender);
        setIdentificattionTypeData(tempIdentification);
        setIsLoading(false);
      }
    });
  }
  console.log(stateProvinceIdData);

  const getCustomerListAction = (offset = 0, limit = Number(tableCount)) => {
    const params = {
      // limit: limit,
      offset: offset,
      orderBy: "id",
      agentMerchantOnly: true,
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;

        const filteredItems = objList.filter((item) => {
          const type = item.agentMerchantData?.agentType;
          return ["AGENT", "MERCHANT", "SUPER_AGENT"].includes(type);
        });

        let tempArray = [];

        filteredItems.forEach((element) => {
          const statusValue = element?.status ? element?.status.value : "-";
          tempArray.push({
            key: element?.agentMerchantData?.id,
            id: element?.agentMerchantData?.id,
            name: element?.displayName ? element?.displayName : "-",
            clientno: element?.accountNo ? element?.accountNo : "-",
            mobileNo: element?.mobileNo ? element?.mobileNo : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
            branch: element?.officeName ? element?.officeName : "-",
            staff: element?.staffName ? element?.staffName : "-",
            branchId: element?.officeId ? element?.officeId : "-",
            agentType: element?.agentMerchantData?.agentType,
          });
        });

        setCustomerList(tempArray);
        setOriginalList(tempArray);
        setIsLoading(false);
      }
    });
  };

  function getAddress() {
    const url = `${apiConfig.FieldConfiguration}/ADDRESS`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        // const objList = res;
      }
    });
  }

  const getProductTemplate = () => {
    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        console.log(res);
        let tempProducts = [];

        objList?.walletsProductDataList.forEach((element) => {
          tempProducts.push({
            value: element.savingsProductData.id,
            label: element.savingsProductData.name
              ? `${element.savingsProductData.name} (${element.id})`
              : "",
          });
        });

        setProductData(tempProducts);
      }
    });
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const handleAddressDelete = (key) => {
    // console.log(key);
    let action = "Delete  ";
    let label = key.title;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = addressList.filter((item) => item.id !== key.id);
        setAddressList(newData);
      },

      function () {
        // No button
      },
    );
  };

  const onFinishgeneralInfoForm = (values) => {
    console.log(values);
    setLegalFormValue(values.legalFormId);
    setFormData({ ...formData, generalInfo: values });

    setCurrent(current + 1);
  };

  const onFinishContactInformationForm = (values) => {
    console.log(values);

    setFormData({ ...formData, contactInfo: values });
    setCurrent(current + 1);
  };

  const onFinishOthersForm = (values) => {
    console.log(values);

    setFormData({ ...formData, othersInfo: values });
    setCurrent(current + 1);
  };

  function onCancel() {
    navigate("/service-provider", { replace: false });
  }

  const forms = [
    <GeneralInformationForm
      onFinish={onFinishgeneralInfoForm}
      form={useForm}
      initialValues={formData.generalInfo}
      isCreateScreen={true}
      userData={userData}
      isActive={isActive}
      legalFormData={legalFormData}
      officeData={officeData}
      legalOption={legalOption}
      customerTypeData={customerTypeData}
      genderData={genderData}
      disabledAfterCurrentDate={disabledAfterCurrentDate}
      agentType={agentTypeWatch}
      customerList={customerList}
      disableDaysBeforeToday={disableDaysBeforeToday}
      clientNonPersonMainBusinessLineOptions={
        clientNonPersonMainBusinessLineOptions
      }
      clientNonPersonConstitutionOptions={clientNonPersonConstitutionOptions}
    />,

    <ContactInformationForm
      onFinish={onFinishContactInformationForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.contactInfo}
      form={useForm}
      identifactionTypeData={identifactionTypeData}
      legalOption={legalFormValue}
      countryData={countryData}
      idType={idType}
      disabledAfterCurrentDate={disabledAfterCurrentDate}
      disableDaysBeforeToday={disableDaysBeforeToday}
      isLoading={isLoading}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      setAddressList={setAddressList}
      addressList={addressList}
      addressTypeIdData={addressTypeIdData}
      stateProvinceIdData={stateProvinceIdData}
      countryIdData={countryIdData}
      handleAddressDelete={handleAddressDelete}
      isCreateScreen={true}
    />,

    <OthersForm
      onFinish={onFinishOthersForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.othersInfo}
      form={useForm}
      walletProduct={productData}
      openCasa={openCasa}
      clientClassificationData={clientClassificationData}
      staffData={staffData}
      isCreateScreen={true}
    />,

    <Preview
      formData={formData}
      // useCases={useCases}
      productData={productData}
      filteredWalletProduct={filteredWalletProduct}
      setAddressList={setAddressList}
      addressList={addressList}
      addressTypeIdData={addressTypeIdData}
      legalFormData={legalFormData}
      officeData={officeData}
      genderData={genderData}
      stateProvinceIdData={stateProvinceIdData}
      countryData={countryData}
      legalOption={legalOption}
      customerList={customerList}
      clientNonPersonConstitutionOptions={clientNonPersonConstitutionOptions}
      clientNonPersonMainBusinessLineOptions={
        clientNonPersonMainBusinessLineOptions
      }
      identifactionTypeData={identifactionTypeData}
      staffData={staffData}
      clientClassificationData={clientClassificationData}
      isCreateScreen={true}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    useForm.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const onSubmit = (formValues) => {
    formValues = {
      ...formData.generalInfo,
      ...formData.contactInfo,
      ...formData.othersInfo,
    };

    formValues.dateOfBirth = formValues.dateOfBirth
      ? BOM.DateTime(formValues.dateOfBirth, "only-date")
      : formValues.dateOfBirth;
    formValues.dateOfIncorporation = formValues.dateOfIncorporation
      ? BOM.DateTime(formValues.dateOfIncorporation, "only-date")
      : formValues.dateOfIncorporation;
    formValues.activationDate = formValues.activationDate
      ? BOM.DateTime(formValues.activationDate, "only-date")
      : formValues.activationDate;
    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(dayjs(), "only-date")
      : formValues.submittedOnDate;
    formValues.idIssuingDate = formValues.idIssuingDate
      ? BOM.DateTime(formValues.idIssuingDate, "only-date")
      : formValues.idIssuingDate;
    formValues.passExpDate = formValues.passExpDate
      ? BOM.DateTime(formValues.passExpDate, "only-date")
      : formValues.passExpDate;

    formValues.clientNonPersonDetails = {
      constitutionId: formValues.constitutionId,
      dateFormat: "dd MMMM yyyy",
      incorpNumber: formValues.incorpNumber,
      incorpValidityTillDate: formValues.incorpValidityTillDate
        ? BOM.DateTime(formValues.incorpValidityTillDate, "only-date")
        : formValues.incorpValidityTillDate,
      locale: "en",
      mainBusinessLineId: formValues.mainBusinessLineId,
      remarks: formValues.remarks,
    };
    console.log("submitting");

    formValues.address = addressList;

    formValues.address?.forEach((element) => {
      delete element.id;
      delete element.description;
      delete element.title;
    });
    delete formValues.productId;
    delete formValues.openCasa;
    delete formValues.constitutionId;
    delete formValues.incorpNumber;
    delete formValues.incorpValidityTillDate;
    delete formValues.mainBusinessLineId;
    delete formValues.remarks;
    console.log(formValues);

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.Clients,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newServiceProviderMsg);
          navigate("/service-provider");
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/service-provider");
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout pageItems={staticConfig.newBreadcrumbItems} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.serviceProvider}
        createPageTitle={labelConfig.createServiceProvider}
      />
      <Spin spinning={isLoading} size="large">
        <div
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            widtth: "100%",
          }}
        >
          {/* Navigation section */}
          <div style={{ width: "288px", padding: "20px 0" }}>
            <Steps
              className="custom-step-style"
              current={current}
              onChange={onChange}
              direction="vertical"
              style={{ height: "723px" }}
              items={[
                {
                  title: <Text strong>General Information</Text>,
                  disabled: !isProductSelected,
                },
                {
                  title: <Text strong>Contact Information</Text>,
                  disabled: !isProductSelected,
                },
                {
                  title: <Text strong>Others</Text>,
                  disabled: !isProductSelected,
                },
                {
                  title: <Text strong>Preview</Text>,
                  disabled: !isProductSelected,
                },
              ]}
            />
          </div>

          {/* Form section */}
          <Card
            style={{
              borderRadius: 20,
              width: "100%",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              padding: "0 20px",
              height: `${current === forms.length - 1 ? "723px" : "100%"}`,
              overflowY: `${current === forms.length - 1 ? "auto" : "hidden"}`,
            }}
          >
            <div style={{ flexGrow: 1 }}>{forms[current]}</div>

            {/* Button Section (at bottom) */}
            <div
              style={{
                paddingTop: 30,
                borderRadius: 20,
              }}
            >
              <Flex justify="end" gap="30px" align="end">
                {current === 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={onCancel}
                  >
                    Go Back
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={prevButtonClick}
                  >
                    Previous
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={nextButtonClick}
                  >
                    Next - {stepTitles[current + 1]}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_BOND") && isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={onSubmit}
                  >
                    {selectedBranchKey ? "Update" : "Submit"}
                  </Button>
                )}
              </Flex>
            </div>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NewServiceProvider);
